import { getRefreshToken } from './token';
export default function checkLogin() {
  return getRefreshToken() !== null;
}